(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".related-products");
  if (!productRecommendationsSection) return;

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      var newContent = container.querySelector(".related-products");
      if (!newContent) return;

      // change this handle to the one you want to hide
      var excludedHandles = ["free-returns-package-protection"];

      // Find product links
      var productLinks = newContent.querySelectorAll("a[href*='/products/']");
      productLinks.forEach(function(a) {
        var href = a.getAttribute("href") || a.href || "";
        var isExcluded = excludedHandles.some(function(h) {
          return href.indexOf("/products/" + h) !== -1;
        });
        if (isExcluded) {
          // Try to remove the card wrapper used by your theme/snippet
          var wrapper = a.closest("[data-product-id], .product-block, .product-grid__item, .product-card, .grid__item, li");
          if (!wrapper) wrapper = a.closest("div"); // last resort
          if (wrapper) wrapper.remove();
        }
      });

      productRecommendationsSection.innerHTML = newContent.innerHTML;
    }
  };
  request.send();
};

document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});

loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
